import * as React from 'react';

import ResearchNav from './nav';
import wechatAuth from './wechatAuth';

import config from '@/server/config';
import request from '@/server/request';

const Toast = require('react-toast-mobile');

export default class ResearchService extends React.Component {
    public state = {
        modelStartTime: '', // 开始时间
        modelEndTime: '', // 结束时间
        cateOne: [], // 一级分类
        cateTwo: [], // 二级分类
        cateOneIndex: 0, // 所选一级分类索引
        cateTwoIndex: 0, // 所选二级分类索引
        special: '', // 没有数据显示的特版
        specialShow: false, // 是否显示特版
        list: [], // 数据
        downloadVisible: false, // 下载面板显示隐藏
        downloadCheckResult: [], // 下载内容
        activityType: 0, // 0 没有购买 1塑料 2化工 12全部
    }

    public componentDidMount() { 

       
        this.checkSpecial();
        this.getUserExpOrderPermission();
        wechatAuth();

        (window as any).jeDate("#startTime", {
            format: "YYYY-MM-DD",
            donefun: (r: any) => { 
                this.setState({
                    modelStartTime: r.val
                });
            }
        });
        (window as any).jeDate("#endTime", {
            format: "YYYY-MM-DD",
            donefun: (r: any) => { 
                this.setState({
                    modelEndTime: r.val
                });
            }
        });
        
    }

    // 是否购买
    private async getUserExpOrderPermission() {
        
        const state = this.state;
        let currentActivityType = state.activityType;
        const r1 = await request({
            url: `${config.API}exp/wap/v2/getUserExpOrderPermission`,
            data: {
                activityType: 1
            }
        });

        const r2 = await request({
            url: `${config.API}exp/wap/v2/getUserExpOrderPermission`,
            data: {
                activityType: 2
            }
        });

        // 没有收费 || 购买了此收费活动
        if (r1.obj.expState || !r1.obj.activityEnable) { 
            currentActivityType = 1
        }
      

        if (r2.obj.expState || !r2.obj.activityEnable) { 
           if(currentActivityType === 1) {
            currentActivityType = 12
           }else {
            currentActivityType = 2
           }
        }
        this.setState({
            activityType: currentActivityType
        });
        this.getCateOne();
        // ['PP', 'PE', 'PVC', 'ABS', 'PS']
        // ['钛白粉', '甲醇', '乙二醇', 'PTA', '苯乙烯']
    }

    public render() {
        const state = this.state;
        return (
            <section>
                <ResearchNav index={2}></ResearchNav>
                <div className={state.specialShow ? 'hide' : ''}>
                    <div className="cx">
                        <div className="jeitem">
                            <label className="jelabel">日期</label>
                            <div className="jeinpbox">
                                <input type="text" className="jeinput" id="startTime" placeholder="开始时间" readOnly={ true } />
                            &nbsp;-&nbsp;
                            <input type="text" className="jeinput" id="endTime" placeholder="结束时间" readOnly={ true } />
                            </div>
                            <button className="btn-cx" onClick={ () => this.searchAction() }>查询</button>
                            <a href="javascript: void(0)" className="xcxz" onClick={ () => this.setDownloadVisible(true) }><img src={require('@/assets/images/download.png')} /></a>
                        </div>
                    </div>
                    <div className="zsfw">
                        <ul className="zsfwnav">
                            {
                                state.cateOne.map((v: any, k: number) => { 
                                    return (
                                        <li key={v.materialFlag} className={state.cateOneIndex === k ? 'current' : ''} onClick={() => this.selectOneCate(k)}>{ v.material }</li>
                                    )
                                })
                            }
                        </ul>
                        <div className="zsfwlist">
                            {
                                state.cateTwo.map((v: any, k: number) => { 
                                    return (
                                        <a href="javascript: void(0)" key={v.id} className={state.cateTwoIndex === k ? 'current' : ''} onClick={() => this.selectTwoCate(k)}>{ v.materialName }</a>
                                    )
                                }) 
                            }
                        </div>
                    </div>
                    <table className="tableList">
                    <thead>
                        <tr>
                            <th className="th01">序号</th>
                            <th className="th02">日期</th>
                            <th className="thItem" id="th_title">产能</th>
                        </tr>
                    </thead>
                        <tbody id="data-tasle">
                            {
                                state.list.map((v: any, k: number) => { 
                                    return (
                                        <tr key={ v.id }>
                                            <td>{ k+1 }</td>
                                            <td>{ v.exponentialDateStr }</td>
                                            <td>{ v.exponential }</td>
                                        </tr>
                                    )
                                })
                            }
                    </tbody>
                </table>
                </div>
                <div className={!state.specialShow ? 'hide' : ''} dangerouslySetInnerHTML={{ __html: state.special }}></div>
                <div className={`download-panel ${state.downloadVisible ? 'active' : ''}`}>
                    <div className="cjCon">
                        <div className="fctop"> <h3>下载</h3></div>
                        <span className="close" onClick={ () => this.setDownloadVisible(false)}></span>
                        <div className="tit">{ state.cateOne[state.cateOneIndex] ? state.cateOne[state.cateOneIndex]['material'] : ''}指数</div>
                        <div className="zsipt">
                            <ul className="zsdyinput">
                                {
                                    state.cateTwo.map((v: any, k: number) => { 
                                        return (
                                            <li key={ v.id }>
                                                <input type="checkbox" id={'cateTwoItem' + k} onClick={ () => this.downloadItemCheck(k) }/>
                                                <label htmlFor={ 'cateTwoItem' + k }>{ v.materialName }</label>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                        <button onClick={ () => this.downloadAction() }>下载</button>
                    </div>
                </div>
            </section>
        )
    }

    // 获取一级分类
    private async getCateOne() { 
        const activityType = this.state.activityType;
        const r = await request({
            url: `${config.API}exp/wap/data/exponential/nav`
        });

        // ['PP', 'PE', 'PVC', 'ABS', 'PS']
        // ['钛白粉', '甲醇', '乙二醇', 'PTA', '苯乙烯']
        if (r.code === 1) { 
            let filterArr = r.obj
            if(activityType === 1) {
                filterArr = r.obj.filter((elem: { material: string; }) => {
                    return ['PP', 'PE', 'PVC', 'ABS', 'PS'].includes(elem.material)
                });
            }

            if(activityType === 2) {
                filterArr = r.obj.filter((elem: { material: string; }) => {
                    return ['钛白粉', '甲醇', '乙二醇', 'PTA', '苯乙烯'].includes(elem.material)
                });
            }

            this.setState({
                cateOne: filterArr
            });

            if (r.obj.length > 0) { 
                this.getCateTwo();
            }
            
        }
    }

    // 获取二级分类
    private async getCateTwo() { 
        const r = await request({
            url: `${config.API}exp/wap/data/exponential/subnav?queryFlag=${this.state.cateOne[this.state.cateOneIndex]['materialFlag']}`
        });

        if (r.code === 1) {
            this.setState({
                cateTwo: r.obj,
                downloadCheckResult: new Array(r.obj ? r.obj.length : 0).fill(false)
            }, () => {
                this.getList();
            });
        }
    }

    // 获取没有数据时显示的特版
    private async getSpecial() { 
        const r = await request({
            url: `${config.API}api/specialcontent/get?code=005021005002`
        });

        if (r.code === 0) { 
            this.setState({
                special: r.data.formalContent
            });
        }
    }

    /**
     * 获取列表数据
     * @param flag 二级flag值 
     */
    private async getList() {
        const state = this.state;
        const cateOne = state.cateOne[state.cateOneIndex];
        const cateTwo = state.cateTwo[state.cateTwoIndex];
        const r = await request({
            url: `${config.API}exp/getOneCharts`,
            method: 'post',
            data: {
                materialFlag: cateOne ? cateOne['materialFlag'] : '',
                startTime: state.modelStartTime,
                endTime: state.modelEndTime,
                queryFlag: cateTwo ? cateTwo['queryFlag'] : ''
            }
        });

        if (r.code === 1) { 
            this.setState({
                list: r.obj || [],
                specialShow: !r.obj || r.obj.length === 0
            });
        }

        if(state.activityType === 0) {
            this.setState({
                specialShow: true
            });
            this.getSpecial();
        }
    }

    /**
     * 选择一级分类
     * @param index 分类索引
     */
    private selectOneCate(index: number) { 
        if (this.state.cateOneIndex === index) { 
            return;
        }

        this.setState({
            cateTwo: [],
            cateTwoIndex: 0,
            cateOneIndex: index,
            list: [],
            downloadCheckResult: []
        }, () => { 
                this.getCateTwo();
        });
    }

    /**
     * 选择二级分类
     * @param index 分类索引
     */
    private selectTwoCate(index: number) { 
        if (this.state.cateTwoIndex === index) { 
            return;
        }

        this.setState({
            list: [],
            cateTwoIndex: index
        }, () => { 
                this.getList();
        });
    }

    // 搜索
    private searchAction() { 
        this.setState({
            list: [],
        }, () => { 
                this.getList();
        });
    }

    /**
     * 显示隐藏下载面板
     * @param visible {boolean} 显示隐藏
     */
    private setDownloadVisible(visible: boolean) { 
        this.setState({
            downloadVisible: visible
        });
    }

    /**
     * 选择下载内容
     * @param index 索引
     */
    private downloadItemCheck(index: number) { 
        this.setState({
            downloadCheckResult: this.state.downloadCheckResult.map((v: any, k: number) => k === index ? !v : v)
        });
    }

    // 下载
    private async downloadAction() { 
        const state = this.state;

        if (state.downloadCheckResult.some((v: any) => v)) {
            const attr: any[] = [];
            state.cateTwo.forEach((v: any, k: number) => { 
                if (state.downloadCheckResult[k]) { 
                    attr.push(v.queryFlag);
                }
            });

            window.location.href = `${config.API}exp/outExcel?arrStr=${attr.join(',')}&materialFlag=${state.cateOne[state.cateOneIndex]['materialFlag']}`;

            // const r = await request({
            //     url: `${config.API}exp/outExcel?arrStr=${attr.join(',')}&materialFlag=${state.cateOne[state.cateOneIndex]['materialFlag']}`
            // });

            // if (r.code === 1) { 

            // }
        } else { 
            Toast.T.notify('请选择需要下载的内容');
        }
    }

    // 检测是否需要显示特版
    private async checkSpecial() { 
        const r = await request({
            url: `${config.API}exp/wap/data/exponential/hasData`
        });

        if (r.code === 1) { 
            if (r.obj <= 0) { 
                this.setState({
                    specialShow: true
                });
                this.getSpecial();
            }
        }
    }
}